import { TableCell } from '@mui/material';

import { menuTypes } from '@/shared/components';
import { ColumnProps, ItemSelectionApiProps } from '@/shared/components/table/duck/types';

import { bodyRowUtils } from '../duck';
import { StyledGroupRow } from './grouped-row.styped';

interface GroupedRowProps<DataItem> {
  columns: ColumnProps<DataItem>[];
  group: string;
  itemSelection?: ItemSelectionApiProps<DataItem>;
  itemActions?: (item: DataItem) => menuTypes.UIMenuProps;
}

const GroupedRow = <DataItem, >({
  columns,
  group,
  itemSelection,
  itemActions,
}: GroupedRowProps<DataItem>) => {
  return (
    <StyledGroupRow>
      <TableCell
        colSpan={
          bodyRowUtils.calculateTotalColSpan({
            columns,
            itemSelection,
            itemActions,
          },
          )}
      >
        {group}
      </TableCell>
    </StyledGroupRow>
  );
};

export default GroupedRow;